import { NgModule, ApplicationRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AgmCoreModule } from '@agm/core';
import { StickyModule } from 'ng2-sticky-kit/ng2-sticky-kit';

import { AppComponent } from './app.component';
// components
import { HomeComponent } from './home/home.component';
import { ApiDocsComponent } from './api-docs';
import { TestConnectionComponent } from './test-connection';
import { SchedulesComponent } from './schedules/schedules.component';
import { PortsComponent } from './ports/ports.component';
import { CarriersComponent } from './carriers/carriers.component';
import { VesselsComponent } from './vessels/vessels.component';
import { WebSearchComponent } from './web-search/web-search.component';
import { PlansComponent } from './plans/plans.component';
import { AboutComponent, ApiComponent, AnalyticsComponent, ContactComponent, DataFeedsComponent, PrivacyPolicyComponent, TermsOfUseComponent, HelpComponent, SolutionsComponent, ApplicationComponent, WhatWeDoComponent, OnlineSearchComponent, DataFormatsComponent, CarrierNetworkComponent, ApiOverviewComponent, DataConsolidationComponent, AboutLandingComponent, UpcomingEventsComponent } from './static';

import { SharedModule } from './shared/shared.module';
import { AccountModule } from './account/account.module';
import { BlogModule } from './blog/blog.module';
import { PressModule } from './press/press.module';

import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { MessageComponent, RegisterMessageComponent, ArrivalMessageComponent, UpgradeMessageComponent, ProfilePopupComponent } from './message/';
import { SaveRouteComponent } from './save-route/save-route.component';
import { CarriersSearchComponent } from './search/carriers-search/carriers-search.component';
import { PortsSearchComponent } from './search/ports-search/ports-search.component';
import { SchedulesSearchComponent } from './search/schedules-search/schedules-search.component';
import { VesselsSearchComponent } from './search/vessels-search/vessels-search.component';
import { ShareResultsComponent } from './share-results/share-results.component';

import { PageNotFoundComponent } from './page-not-found.component';
// Directives
import { ContactCarrierComponent } from './contact-carrier/contact-carrier.component';
import { ContactFormComponent } from './static/contact-form/contact-form.component';
import { ApptFormComponent } from './static/appt-form/appt-form.component';
import { DatePicker } from './shared/date-picker/date-picker.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { Ng5SliderModule } from 'ng5-slider';

// services
import { ApiService } from './shared/api.service';
import { AppContext } from './shared/app.context';
import { AuthService } from './shared/auth.service';
import { CacheService } from './shared/cache.service';
import { FavoriteService } from './shared/favorite.service';
import { LogService } from './shared/logging.service';
import { UserService } from './shared/user.service';
import { SeoService } from './shared/seo.service';

import { AppRoutingModule } from './app-routing.module';

import { removeNgStyles, createNewHosts } from '@angularclass/hmr';

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule, 
    RouterModule,
    AppRoutingModule,
    SharedModule,
    AccountModule,
    BlogModule,
    PressModule,
    StickyModule,
    Ng5SliderModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBEGhrviWvyFDAjzRfnJvXKg__LroVbjLk'   // old key:'AIzaSyDUFqOKzVgnxyCsH_GR0yyjTFcLtSoCThc'
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    HomeComponent,
    ApiDocsComponent,
    TestConnectionComponent,
    SchedulesComponent,
    PortsComponent,
    CarriersComponent,
    VesselsComponent,
    WebSearchComponent,
    PlansComponent,
    DataFeedsComponent,
    AboutComponent,
    ApiComponent,
    AnalyticsComponent,
    ShareResultsComponent,
    ContactCarrierComponent,
    ContactComponent,
    PrivacyPolicyComponent,
    TermsOfUseComponent,
    RegisterComponent,
    LoginComponent,
    MessageComponent,
    RegisterMessageComponent,
    ArrivalMessageComponent,
    UpgradeMessageComponent,
    ProfilePopupComponent,
    SaveRouteComponent,
    CarriersSearchComponent,
    PortsSearchComponent,
    SchedulesSearchComponent,
    VesselsSearchComponent,
    DatePicker,
    ContactFormComponent,
    ApptFormComponent,
    ConfirmComponent,
    HelpComponent,
    SolutionsComponent,
    ApplicationComponent,
    WhatWeDoComponent,
    OnlineSearchComponent,
    ApiOverviewComponent,
    CarrierNetworkComponent,
    DataConsolidationComponent,
    DataFormatsComponent,
    AboutLandingComponent,
    UpcomingEventsComponent, 
    PageNotFoundComponent
  ],
  providers: [
    Title,
    ApiService,
    AppContext,
    AuthService,
    CacheService,
    FavoriteService,
    LogService,
    UserService,
    SeoService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public appRef: ApplicationRef) { }
  hmrOnInit(store) {
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/app.module.ts